import { jsx as _jsx } from "react/jsx-runtime";
import { lazy } from "react";
import ContentBox from "../../ContentBox";
import ShowChartIcon from "@material-ui/icons/ShowChart";
import { FormattedMessage } from "react-intl";
import { validChartData } from "./common";
import { ChartResource } from "@ploy-lib/rest-resources";
const ChartContent = lazy(() => import(/* webpackChunkName: "chart"  */ "./ChartContent"));
const Charts = props => {
    const { source, boxProps, placeholder } = props;
    return (_jsx(ContentBox, { avatar: _jsx(ShowChartIcon, {}), header: _jsx(FormattedMessage, { id: "dealer.dashboard.statistics.header", defaultMessage: "Statistics", description: "Label for statistics header" }), ...boxProps, children: _jsx(ChartContent, { source: source, placeholder: placeholder }) }));
};
const resources = ({ source }) => [[ChartResource[source ?? "detail"]?.(), source ? {} : null]];
Charts.getPrefetch = resources;
Charts.getVisibilityFetch = resources;
Charts.getVisibility = (props, [chartData]) => validChartData(chartData);
Charts.displayName = "DployDashboardCharts";
export default Charts;
//# sourceMappingURL=Charts.js.map